import { useEffect, useState } from "react";

export const useFetchDistributorFulfillment = (distributorId) => {
    const [distributorFulfillment, setDistributorFulfillment] = useState(null);

    useEffect(() => {
        const fetchDistributorFulfillment = async () => {
            try {
                const rsp = await fetch(`api/fulfillmentStatus`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ distributors: [{ distributorId: Number(distributorId) }] }),
                });
                const text = await rsp.text();
                if (!rsp.ok) {
                    console.error(`fulfillmentStatus byDistributor ${distributorId} failed: ${rsp.status}`, text || "(empty body)");
                    setDistributorFulfillment([]);
                    return;
                }
                if (!text || !text.trim()) {
                    console.error(`fulfillmentStatus byDistributor ${distributorId}: empty response body`);
                    setDistributorFulfillment([]);
                    return;
                }
                setDistributorFulfillment(JSON.parse(text));
            } catch (e) {
                console.error(`fulfillmentStatus byDistributor ${distributorId}:`, e);
                setDistributorFulfillment([]);
            }
        };
        fetchDistributorFulfillment();
    }, [distributorId]);

    return distributorFulfillment;
};
